var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 403,
    viewBox: "0 0 403 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8236 156.61C20.1257 242.742 70.1044 332.909 156.236 357.607C242.368 382.304 332.536 332.324 357.234 246.192C357.69 244.599 356.768 242.936 355.176 242.479C353.581 242.022 351.92 242.944 351.463 244.537C327.677 327.488 240.841 375.622 157.891 351.836C74.9426 328.051 26.8085 241.215 50.5941 158.264C74.3792 75.3163 161.215 27.1821 244.164 50.9671C245.758 51.4244 247.42 50.5019 247.876 48.9093C248.333 47.3166 247.413 45.6538 245.818 45.1965C159.687 20.4986 69.5215 70.478 44.8236 156.61Z",
    fill: "#8753F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePurple);
export default __webpack_public_path__ + "static/media/circle-purple.8fff1bebabb96b06545e39e142db9bf0.svg";
export { ForwardRef as ReactComponent };